import {
  SET_PAGE,
  SET_SEARCH,
  GET_USERS,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialUsers = {
  users: [],
  userCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const usersReducer = (state = initialUsers, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload.admins.map((user) => {
          return {
            ...user,

            updatedAtFormatted: moment(user.createdAt).format("ll"),
          };
        }),
        userCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };

    default:
      return state;
  }
};

export default usersReducer;
